module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main